module.exports = __webpack_public_path__ + "img/9788925553696.2202aafc.jpg";